var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useState } from 'react';
import useLocalization from '../../../../../../hooks/useLocalization';
import { Lang } from '@brg/api';
import ReactMarkdown from 'react-markdown';
import { FlexBox, useBreakpoint, useToasts } from '@brg/ui';
import { Description, FormViewContainer, Header, PndText, SendButton, PpdWithCheckMarkText } from '../styles';
import { FormInputs } from './FormInputs';
import { FORM_POSITION_TYPE } from '../../../editor/newel';
import { markdownComponentsController } from '../../../markdown/markdownComponentsController';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { Input } from '@brg/input';
var transformInlineVariants = function (dataArray, language) {
    if (language === void 0) { language = 'ru'; }
    return dataArray.map(function (item) {
        if (!item.hasOwnProperty('inlineVariants') || !Array.isArray(item.inlineVariants)) {
            return __assign(__assign({}, item), { options: [] });
        }
        var options = item.inlineVariants.map(function (variant) {
            if (!Array.isArray(variant) || variant.length === 0) {
                return { label: '', value: '' };
            }
            var languageVariant = variant.find(function (v) { return v.lang === language; });
            if (!languageVariant) {
                var fallbackVariant = variant[0] || { name: '' };
                return {
                    label: fallbackVariant.name,
                    value: fallbackVariant.name,
                };
            }
            return {
                label: languageVariant.name,
                value: languageVariant.name,
            };
        });
        return __assign(__assign({}, item), { options: options });
    });
};
export var FormView = function (_a) {
    var form = _a.form, inputsValues = _a.inputsValues, colorStyle = _a.colorStyle, post = _a.post, onSend = _a.onSend, isEditable = _a.isEditable, onInputsChange = _a.onInputsChange, onDropdownChange = _a.onDropdownChange, position = _a.position, isDisabled = _a.isDisabled, isPpdAccepted = _a.isPpdAccepted, setIsPpdAccepted = _a.setIsPpdAccepted;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var toasts = useToasts();
    var is568 = useBreakpoint(568);
    var formPosition = useMemo(function () { return (position && FORM_POSITION_TYPE[Number(position === null || position === void 0 ? void 0 : position.formPosition)]); }, [position]);
    var header = useMemo(function () { return (Lang(form === null || form === void 0 ? void 0 : form.header, language)); }, [form, language]);
    var description = useMemo(function () { return (Lang(form === null || form === void 0 ? void 0 : form.description, language)); }, [form, language]);
    var fields = useMemo(function () { return (transformInlineVariants(inputsValues, language)); }, [inputsValues, language]);
    var pndText = useMemo(function () { var _a, _b; return (Lang((_b = (_a = form === null || form === void 0 ? void 0 : form.pndFields) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value, language)); }, [form, language]);
    var btnText = useMemo(function () { return (Lang(form === null || form === void 0 ? void 0 : form.textSubmitButton, language)); }, [form, language]);
    var _c = useState({}), ppdAcceptedStates = _c[0], setPpdAcceptedStates = _c[1];
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var TextWithLinks = function (_a) {
        var _b;
        var text = _a.text, language = _a.language;
        return ((_b = text === null || text === void 0 ? void 0 : text.split(urlRegex)) === null || _b === void 0 ? void 0 : _b.map(function (part, i) {
            return urlRegex.test(part) ? (React.createElement("a", { key: i, href: part, target: "_blank", rel: "noopener noreferrer" }, part)) : (part);
        }));
    };
    var ppdItems = useMemo(function () {
        var _a;
        if (!((_a = form === null || form === void 0 ? void 0 : form.ppdWithCheckMark) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        return form.ppdWithCheckMark.map(function (ppdGroup) {
            return ppdGroup.filter(function (item) { return item.name; });
        }).filter(function (group) { return group.length > 0; });
    }, [form === null || form === void 0 ? void 0 : form.ppdWithCheckMark]);
    useEffect(function () {
        var initialStates = {};
        ppdItems.forEach(function (_, index) {
            initialStates[index] = false;
        });
        setPpdAcceptedStates(initialStates);
    }, [ppdItems]);
    var handlePpdAcceptChange = function (index) {
        setPpdAcceptedStates(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[index] = !prev[index], _a)));
        });
    };
    var allPpdAccepted = useMemo(function () {
        return Object.values(ppdAcceptedStates).every(function (accepted) { return accepted; });
    }, [ppdAcceptedStates]);
    return (React.createElement(FormViewContainer, { colorStyle: colorStyle, position: formPosition },
        React.createElement(Header, { colorStyle: colorStyle, position: formPosition }, header),
        React.createElement(Description, { colorStyle: colorStyle, position: formPosition },
            React.createElement(ReactMarkdown, { components: markdownComponentsController, rehypePlugins: [rehypeRaw, [rehypeSanitize, { protocols: { href: ['http', 'https', 'hseverse'] } }]] }, description)),
        React.createElement(FormInputs, { position: formPosition, inputs: fields, colorStyle: colorStyle, isEditable: isEditable || isDisabled, onDropdownChange: onDropdownChange, onInputsChange: onInputsChange, isDisabled: true }),
        React.createElement(FlexBox, { offsetTop: 16, offsetTopMobile: 16, direction: 'row', directionMobile: is568 ? 'column-reverse' : 'row', align: 'center', width: '100%', justify: 'space-between', justifyMobile: 'space-between', gx: is568 ? 0 : 32, gxMobile: is568 ? 0 : 32 },
            React.createElement(PndText, null,
                React.createElement(TextWithLinks, { text: Lang(pndText, language) })),
            React.createElement(SendButton, { disabled: isEditable || isDisabled || !allPpdAccepted, onClick: onSend, colorStyle: colorStyle }, btnText)),
        ppdItems.length > 0 && (React.createElement(FlexBox, { offsetTop: 24, align: "flex-start", direction: 'column' }, ppdItems.map(function (ppdItem, index) { return (React.createElement(FlexBox, { key: index, direction: "row", align: "flex-start", offsetTop: index > 0 ? 8 : 0 },
            React.createElement(Input.Checkbox, { title: "", checked: ppdAcceptedStates[index] || false, onChange: function () { return handlePpdAcceptChange(index); } }),
            React.createElement(PpdWithCheckMarkText, null,
                React.createElement(TextWithLinks, { text: Lang(ppdItem, language) })))); })))));
};
//# sourceMappingURL=FormView.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useState } from 'react';
import useLocalization from '../../../../../../hooks/useLocalization';
import { Lang } from '@brg/api';
import ReactMarkdown from 'react-markdown';
import { FlexBox, useBreakpoint, useToasts } from '@brg/ui';
import { Description, FormViewContainer, Header, PndText, SendButton, PpdWithCheckMarkText } from '../styles';
import { FormInputs } from './FormInputs';
import { FORM_POSITION_TYPE } from '../../../editor/newel';
import { markdownComponentsController } from '../../../markdown/markdownComponentsController';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import { Input } from '@brg/input';
var transformInlineVariants = function (dataArray, language) {
    if (language === void 0) { language = 'ru'; }
    return dataArray.map(function (item) {
        if (!item.hasOwnProperty('inlineVariants') || !Array.isArray(item.inlineVariants)) {
            return __assign(__assign({}, item), { options: [] });
        }
        var options = item.inlineVariants.map(function (variant) {
            if (!Array.isArray(variant) || variant.length === 0) {
                return { label: '', value: '' };
            }
            var languageVariant = variant.find(function (v) { return v.lang === language; });
            if (!languageVariant) {
                var fallbackVariant = variant[0] || { name: '' };
                return {
                    label: fallbackVariant.name,
                    value: fallbackVariant.name,
                };
            }
            return {
                label: languageVariant.name,
                value: languageVariant.name,
            };
        });
        return __assign(__assign({}, item), { options: options });
    });
};
export var FormView = function (_a) {
    var form = _a.form, inputsValues = _a.inputsValues, colorStyle = _a.colorStyle, post = _a.post, onSend = _a.onSend, isEditable = _a.isEditable, onInputsChange = _a.onInputsChange, onDropdownChange = _a.onDropdownChange, position = _a.position, isDisabled = _a.isDisabled, isPpdAccepted = _a.isPpdAccepted, setIsPpdAccepted = _a.setIsPpdAccepted;
    var _b = useLocalization(), t = _b.t, language = _b.language;
    var toasts = useToasts();
    var is568 = useBreakpoint(568);
    var formPosition = useMemo(function () { return (position && FORM_POSITION_TYPE[Number(position === null || position === void 0 ? void 0 : position.formPosition)]); }, [position]);
    var header = useMemo(function () { return (Lang(form === null || form === void 0 ? void 0 : form.header, language)); }, [form, language]);
    var description = useMemo(function () { return (Lang(form === null || form === void 0 ? void 0 : form.description, language)); }, [form, language]);
    var fields = useMemo(function () { return (transformInlineVariants(inputsValues, language)); }, [inputsValues, language]);
    var pndText = useMemo(function () { var _a, _b; return (Lang((_b = (_a = form === null || form === void 0 ? void 0 : form.pndFields) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value, language)); }, [form, language]);
    var btnText = useMemo(function () { return (Lang(form === null || form === void 0 ? void 0 : form.textSubmitButton, language)); }, [form, language]);
    var _c = useState({}), ppdAcceptedStates = _c[0], setPpdAcceptedStates = _c[1];
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var TextWithLinks = function (_a) {
        var _b;
        var text = _a.text, language = _a.language;
        return ((_b = text === null || text === void 0 ? void 0 : text.split(urlRegex)) === null || _b === void 0 ? void 0 : _b.map(function (part, i) {
            return urlRegex.test(part) ? (React.createElement("a", { key: i, href: part, target: "_blank", rel: "noopener noreferrer" }, part)) : (part);
        }));
    };
    var ppdItems = useMemo(function () {
        var _a;
        if (!((_a = form === null || form === void 0 ? void 0 : form.ppdWithCheckMark) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        return form.ppdWithCheckMark.map(function (ppdGroup) {
            return ppdGroup.filter(function (item) { return item.name; });
        }).filter(function (group) { return group.length > 0; });
    }, [form === null || form === void 0 ? void 0 : form.ppdWithCheckMark]);
    useEffect(function () {
        var initialStates = {};
        ppdItems.forEach(function (_, index) {
            initialStates[index] = false;
        });
        setPpdAcceptedStates(initialStates);
    }, [ppdItems]);
    var handlePpdAcceptChange = function (index) {
        setPpdAcceptedStates(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[index] = !prev[index], _a)));
        });
    };
    var allPpdAccepted = useMemo(function () {
        return Object.values(ppdAcceptedStates).every(function (accepted) { return accepted; });
    }, [ppdAcceptedStates]);
    return (React.createElement(FormViewContainer, { colorStyle: colorStyle, position: formPosition },
        React.createElement(Header, { colorStyle: colorStyle, position: formPosition }, header),
        React.createElement(Description, { colorStyle: colorStyle, position: formPosition },
            React.createElement(ReactMarkdown, { components: markdownComponentsController, rehypePlugins: [rehypeRaw, [rehypeSanitize, { protocols: { href: ['http', 'https', 'hseverse'] } }]] }, description)),
        React.createElement(FormInputs, { position: formPosition, inputs: fields, colorStyle: colorStyle, isEditable: isEditable || isDisabled, onDropdownChange: onDropdownChange, onInputsChange: onInputsChange, isDisabled: true }),
        React.createElement(FlexBox, { offsetTop: 16, offsetTopMobile: 16, direction: 'row', directionMobile: is568 ? 'column-reverse' : 'row', align: 'center', width: '100%', justify: 'space-between', justifyMobile: 'space-between', gx: is568 ? 0 : 32, gxMobile: is568 ? 0 : 32 },
            React.createElement(PndText, null,
                React.createElement(TextWithLinks, { text: Lang(pndText, language) })),
            React.createElement(SendButton, { disabled: isEditable || isDisabled || !allPpdAccepted, onClick: onSend, colorStyle: colorStyle }, btnText)),
        ppdItems.length > 0 && (React.createElement(FlexBox, { offsetTop: 24, align: "flex-start", direction: 'column' }, ppdItems.map(function (ppdItem, index) { return (React.createElement(FlexBox, { key: index, direction: "row", align: "flex-start", offsetTop: index > 0 ? 8 : 0 },
            React.createElement(Input.Checkbox, { title: "", checked: ppdAcceptedStates[index] || false, onChange: function () { return handlePpdAcceptChange(index); } }),
            React.createElement(PpdWithCheckMarkText, null,
                React.createElement(TextWithLinks, { text: Lang(ppdItem, language) })))); })))));
};
//# sourceMappingURL=FormView.js.map